export const WEB_SDK_TEST_ISSUES_CSV_HEADERS = {
	ISSUE_TYPE: 'Issue Type',
	SEVERITY: 'Severity',
	COMPONENT: 'Component',
	URL: 'URL',
	PAGE_TITLE: 'Page Title'
};
export const LABELS = {
	DOWNLOAD_CSV: 'Download CSV'
};
